var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-tooltip',{attrs:{"variant":"primary","label":"Opens the csv upload page in a new tab"}},[_c('button',{class:[
      'tw-flex tw-items-center tw-gap-2',
      'tw-p-3 tw-bg-white tw-shadow-sm tw-rounded-lg',
      'tw-text-[#F1583D] tw-font-medium tw-whitespace-nowrap',
      'tw-border tw-border-solid tw-border-[#DFE2E7] tw-cursor-pointer'
    ],on:{"click":_vm.openCsvUploadPage}},[_c('i',{staticClass:"fa fa-file-csv tw-mr-1"}),_vm._v("\n    Upload CSV\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }